/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ModalComment.vue?vue&type=template&id=22fa61e0"
import script from "./ModalComment.ts?vue&type=script&lang=js&external"
export * from "./ModalComment.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports